import React from 'react';
import {
    Select,
} from '@shopify/polaris';

export function TriggerFormElement(props) {

    return (
        <Select
            label="Trigger"
            options={[
                { label: 'Manual - rule will be executed manually', value: 'Manual' },
                { label: 'Automatic - rule will be triggered when resources are updated/created', value: 'Automatic' },
            ]}
            onChange={(newValue) => props.onFieldValueChange("trigger", newValue)}
            value={props.rule.trigger}
            error={props.ruleErrors["trigger"]}
            helpText={
                <span>
                    Choose when this rule will be triggered.
                </span>
            }
        />
    );
}